import VDraggableAndResizable from './VDraggableAndResizable'

export { VDraggableAndResizable }

export default VDraggableAndResizable